import React from "react";
import "./index.css";
import { Link } from "react-router-dom";
import Logo from "../../images/logo.png";
import shape from "../../images/ft-shape.png";

const ClickHandler = () => {
  window.scrollTo(10, 0);
};
const SubmitHandler = (e) => {
  e.preventDefault();
};

const Footer = (props) => {
  const solutions = [
    { label: "Real Estate", path: "/real-estate-solutions" },
    { label: "Health Care", path: "/healthcare-it-solutions" },
    { label: "Fashion", path: "/fashion-ecommerce-solutions" },
    { label: "IT Solutions", path: "/it-consulting-solutions" },
    { label: "Education", path: "/education-technology-solutions" },
    { label: "Manufacturing", path: "/manufacturing-digital-solutions" },
    { label: "Finance", path: "/finance-software-solutions" },
    { label: "Home & Others", path: "/custom-digital-solutions" },
  ];

  // Split the solutions into two arrays of 4 items each
  const solutionsFirstHalf = solutions.slice(0, 4);
  const solutionsSecondHalf = solutions.slice(4);

  return (
    <footer className="wpo-site-footer-s2">
      <div className="wpo-upper-footer">
        <div className="container">
          <div className="row">
            <div className="col col-lg-4 col-md-6 col-sm-12 col-12">
              <div className="widget about-widget">
                <div className="logo widget-title">
                  <Link to="/" onClick={ClickHandler}>
                    <img src={Logo} alt="logo" />
                  </Link>
                </div>
                <ul>
                  <li>
                    <a
                      href="https://www.facebook.com/europasolutions"
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={ClickHandler}
                    >
                      <i className="ti-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://x.com/esolutions797"
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={ClickHandler}
                    >
                      <i className="ti-twitter-alt"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/europasolutions/"
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={ClickHandler}
                    >
                      <i className="ti-instagram"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="http://www.youtube.com/@europasolutions7"
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={ClickHandler}
                    >
                      <i className="ti-youtube"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/company/106811026"
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={ClickHandler}
                    >
                      <i className="ti-linkedin"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            {/*
            <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
              <div className="widget newsletter-widget">
                <p>Subscribe our latest news letter.</p>
                <form onSubmit={SubmitHandler}>
                  <div className="input-1">
                    <input
                      type="email"
                      className="form-control footer-input"
                      placeholder="Email Address *"
                      required
                    />
                  </div>
                  <div className="submit">
                    <button type="submit">
                      <i className="fi flaticon-send"></i>
                    </button>
                  </div>
                </form>
              </div>
            </div>
            */}
            <div className="col col-lg-4 col-md-6 col-sm-12 col-12">
              <div className="widget link-widget">
                <div className="widget-title">
                  <h3>Services</h3>
                </div>
                <ul>
                  <li>
                    <Link onClick={ClickHandler} to="/digital-marketing-services">
                      Digital Marketing
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/web-development-services">
                      Web Development
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col col-lg-4 col-md-6 col-sm-12 col-12">
              <div className="widget link-widget">
                <div className="widget-title">
                  <h3>Solutions</h3>
                </div>
                <div className="row">
                  <div className="col-6">
                    <ul>
                      {solutions.slice(0, 4).map((solution, index) => (
                        <li key={index}>
                          <Link onClick={ClickHandler} to={solution.path}>
                            {solution.label}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="col-6">
                    <ul>
                      {solutions.slice(4).map((solution, index) => (
                        <li key={index}>
                          <Link onClick={ClickHandler} to={solution.path}>
                            {solution.label}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr className="footer-separator" />
      <div className="footer-bottom">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 navLinks">
              <ul>
                {[
                  { label: "Terms of use", path: "/terms-conditions" },
                  { label: "Privacy policy", path: "/privacy-policy" },
                  { label: "Cookie policy", path: "/cookies-policy" },
                ].map((link, index) => (
                  <li key={index}>
                    <Link className="text-white" to={link.path} onClick={ClickHandler}>
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className="col-lg-6 copyWrite">
              <p>©Europa Solutions Limited 2024 | Company number:  07827816</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
